<!-- Latest Jobs -->
<div class="jobs pd-tb">
	<div class="container">
		<!-- <app-applied-saved-jobs-details [job]="job" [jobDetail]="jobDetail" [fromAppliedJobs]="true"></app-applied-saved-jobs-details> -->
		<div class="col-sm-12">
			<div>
				<ol class="breadcrumb">
					<li class="breadcrumb-item"> <a routerLink="/dashboard-job">Home</a></li>
					<li class="breadcrumb-item active"> <a routerLink="/all-jobs">All Jobs</a></li>
					<li class="breadcrumb-item active">
						<a>
							{{jobsType == "search" ? 'Search' : jobsType == "applied" ? "Applied Jobs" :
							jobsType == "saved" ? "Saved Jobs" :
							jobsType == "recommanded" ? "Recommended Jobs" :
							jobsType == "industry" ? "Industry Jobs" : jobsType == "roles" ? "Job Roles" : ""}}
						</a>
					</li>
				</ol>
			</div>
		</div>
		<div class="row p-0">
		<div class="col-sm-12 col-lg-4 col-md-12 ">
			<div class="infinite-scroll scrollbar3" id="style-1" infinite-scroll
				[infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
				[scrollWindow]="false" (scrolled)="onModalScrollDown()">
				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngFor="let job of jobsData">
					<div class="card-grid-2" [ngClass]="{'active':jobID == (job?.job_post?.id || job?.id) }">
						<app-details-job-item (click)="goToJobDetail(job?.job_post?.id || job?.id)"
							[job]="job?.job_post || job" (onJobSaved)="saveUnsaveJob($event,1)"></app-details-job-item>
					</div>
				</div>
			</div>
			</div>

			<!-- Job Details -->
			<div *ngIf="jobDetailsData" class="col-sm-12 col-lg-8 col-md-8 jobDetails">
				<div class="jobDesp">
					<div class="card-grid-2">
						<div class="card-grid-2-image-left">
							<div class="jobsdiv">
								<div class="image-box">
									<img src="{{jobDetailsData?.recruiter?.profileImage != null ? recruiterImagePath : ''}}{{jobDetailsData?.recruiter?.profileImage == null ? 'assets/images/profile-img.jpg':jobDetailsData?.recruiter?.profileImage}}"
										alt="jobBox">
								</div>
								<div class="right-info">
									<a class="name-job"
										href="javascript:void(0);">{{jobDetailsData?.recruiter?.companyName}}
										<span *ngIf="jobDetailsData?.JobPost?.isfeatured == 1"
											class="featured">Featured</span>
									</a>
									<span class="location-small">
										{{jobDetailsData?.JobPost?.workPlaceLocation == "Remote" ? "Remote" : jobDetailsData?.JobPost?.location}}

									</span>
								</div>
							</div>
							<div class="apply">
								<img src="{{jobDetailsData?.JobPost?.saveStatus == 0 ?  'assets/images/ic_unsave.svg':'assets/images/saved_job.svg'}}"
									alt="unsave"  tooltip="Save" title="Save" placement="bottom"
									(click)="saveUnsaveJob(jobDetailsData.JobPost,2);$event.stopPropagation()">
								<a *ngIf="jobDetailsData?.JobPost?.isApplyed == 1" routerLink="/chat"
									[queryParams]="{'id':jobDetailsData.JobPost.id}"
									class="applybtn borderBtn">Message</a>
								<a *ngIf="jobDetailsData?.JobPost?.isApplyed == 1"
									(click)="withdrawJob(jobDetailsData?.JobPost?.id)"
									class="applybtn borderBtn fill">Withdraw</a>
								<a *ngIf="jobDetailsData?.JobPost?.isApplyed == 0"
									(click)="applyJob(jobDetailsData?.JobPost?.id, jobDetailsData?.recruiter?.id )"
									class="applybtn borderBtn fill">Apply now</a>
							</div>
						</div>
					</div>
					<div class="card-block-inner p-0">
						<h6 class="cap">{{jobDetailsData?.JobPost?.jobTitle}}</h6>
					</div>
					<div class="row m-0">
						<div class="col-sm-6 descrpinner">
							<span>
								<!-- <img src="assets/images/ic_price.svg"> -->
								{{jobSalary(jobDetailsData?.JobPost)}}
							</span>
						</div>
						<div class="col-sm-6 descrpinner">
							<span><img src="assets/images/ic_applicant.svg">{{jobDetailsData?.JobPost?.applicantsCount}}
								applicants</span>
						</div>
						<div class="col-sm-6 descrpinner">
							<span><img
									src="assets/images/ic_clock.svg">{{jobDetailsData?.JobPost?.schedulesName}}</span>
						</div>
						<div class="col-sm-6 descrpinner">
							<span><img
									src="assets/images/ic_jobtime.svg">{{jobDetailsData?.JobPost?.EmploymentTypesName}}</span>
						</div>
					</div>
					<div class=" col-sm-12 cards-inner2">
						<span class="card-time">Job start date: {{jobDetailsData?.JobPost?.createdAt | date }} </span>
						<span style="color:#d7d7d9"> | </span>
						<span class="card-applicants">Posted: {{dateInMilisecond(jobDetailsData?.JobPost?.createdAt) |
							dateAgoConvertor}}</span>
					</div>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Job description</h6>
					<ul class="jobdeslist">
						<li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.description || "-"}}</li>
					</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Skills</h6>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostSkills.length > 0">
						<li *ngFor="let skill of jobDetailsData?.JobPostSkills">{{skill?.skillsName}}</li>
					</ul>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostSkills.length == 0">-</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Benefits</h6>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostBenefits.length > 0">
						<li *ngFor="let benefit of jobDetailsData?.JobPostBenefits">{{benefit?.benefitsName}}</li>
					</ul>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostBenefits.length == 0">-</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Category</h6>
					<ul class="jobdeslist">
						<li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.categoryName || "-"}}</li>
					</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Sub-Category</h6>
					<ul class="addedskills" *ngIf="jobDetailsData?.subCategory.length > 0">
						<li *ngFor="let cat of jobDetailsData?.subCategory">{{cat?.subCategoryName}}</li>
					</ul>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostBenefits.length == 0">-</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Veteran Status</h6>
					<ul class="addedskills" *ngIf="jobDetailsData?.jobEligibleFor.length > 0">
						<li *ngFor="let vet of jobDetailsData?.jobEligibleFor">{{vet?.eligibles_name}}</li>
					</ul>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostBenefits.length == 0">-</ul>
				</div>
				
				<div class="innerdes">
					<h6 class="heading-6">Industries</h6>
					<ul class="addedskills">
						<li>{{jobDetailsData?.JobPost?.industriesName || "-"}}
						</li>
					</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Supplemental pay</h6>
					<ul class="addedskills" *ngIf="jobDetailsData?.supplementalPay.length > 0">
						<li *ngFor="let pay of jobDetailsData?.supplementalPay">{{pay?.supplements_name}}</li>
					</ul>
					<ul class="addedskills" *ngIf="jobDetailsData?.supplementalPay.length == 0">-</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">16 Personalities</h6>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostPersonalities.length > 0">
						<li *ngFor="let person of jobDetailsData?.JobPostPersonalities">{{person?.personalitiesName}}</li>
					</ul>
					<ul class="addedskills" *ngIf="jobDetailsData?.JobPostPersonalities.length == 0">-</ul>
				</div>
				<div class="innerdes">
					<h6 class="heading-6">Number of positions</h6>
					<ul class="jobdeslist">
						<li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.noOfPeopleRequired || "-"}}
						</li>
					</ul>
				</div>
				
				<div class="innerdes">
					<h6 class="heading-6">Must Haves</h6>
					<ul class="jobdeslist">
						<li><img src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.vaccinationCerificate == 1 ?
							"Covid-19 vaccination certificate required" : "Covid-19 vaccination certificate not
							required"}}</li>
						<li *ngIf="jobDetailsData?.JobPost?.travelRequirementsName"><img
								src="assets/images/bullet.svg">{{jobDetailsData?.JobPost?.travelRequirementsName}}</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</div>